var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"module-head"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.action)?_c('button',{on:{"click":function($event){return _vm.$emit('more')}}},[_vm._v(_vm._s(_vm.action)+" "),_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }